module.exports = __webpack_public_path__ + "static/media/logo.b5edbd4f.png";